<template>
  <div id="app">
    <!-- 手机导航栏 -->
    <mobile-header-nav v-if="$route.meta.isMobile || mobileOnOff"></mobile-header-nav>
    <!-- 导航栏 -->
    <header-nav v-else></header-nav>
    <!-- 内容 -->
    <div id="main_box">
      <router-view v-if="isRouterAlive"></router-view>
    </div>
    <!-- 手机页脚 -->
    <mobile-footer-nav v-if="$route.meta.isMobile || mobileOnOff"></mobile-footer-nav>
    <!-- 页脚 -->
    <footer-nav v-else></footer-nav>
    <!-- 右侧快捷操作栏 -->
    <suspension-right v-if="!$route.meta.isSuspensionRight"></suspension-right>
  </div>
</template>

<script>
import header from './views/Public/header.vue'
import footer from './views/Public/footer.vue'
import suspension from './views/Public/suspension.vue'
import mobileHeader from './views/Mobile/headerM.vue'
import mobileFooter from './views/Mobile/footerM.vue'
export default {
  components: {
    headerNav: header, // 头部
    footerNav: footer, // 底部
    suspensionRight: suspension, // 右侧侧边栏
    mobileHeaderNav: mobileHeader, // 移动端手机头部
    mobileFooterNav: mobileFooter // 移动端手机底部
  },
  provide () { // 父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      mobileOnOff: false, // 监控是否为手机
      isRouterAlive: true // 控制视图是否显示的变量
    }
  },
  created () {
    this.mobileOnOff = this.mycommon.judgeMobile()
    console.log(window.location.href)
  },
  mounted () {
    // 此方法刷新页面时也会执行
    window.addEventListener('beforeunload', () => {
      const beforeUnloadTime = 0
      let gapTime = 0
      window.onunload = function () {
        gapTime = new Date().getTime() - beforeUnloadTime
        if (gapTime <= 5) {
          localStorage.removeItem('user')
        }
      }
    })
  },
  methods: {
    reload () {
      this.isRouterAlive = false // 先关闭
      this.$nextTick(function () {
        this.isRouterAlive = true // 再打开
      })
    }
  }
}
</script>

<style>
  @import "./assets/css/less/main.css"
</style>
